// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"494":"bcc42ff4","510":"5d3de761","613":"3e457525"}[chunkId] + ".chunk.css";
};